import { useState } from "react";
import classNames from "classnames";
import { HiOutlineCubeTransparent } from "react-icons/hi";

import ModalSmartStowArmBin from "./modals/ModalSmartStowArmBin";

export default function SmartStowArmBin({ system }) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <button
                className={classNames(
                    "flex justify-center items-center gap-2 bg-white text-sm py-2 px-4 border border-sky-600 rounded",
                    "text-sky-600 hover:text-sky-950 hover:border-sky-950"
                )}
                onClick={() => setIsModalOpen(true)}
            >
                <HiOutlineCubeTransparent fontSize={24} />
                Arm Bin
            </button>

            <ModalSmartStowArmBin
                system={system}
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
            />
        </>
    );
}
